import { Info } from '@mui/icons-material';
import { Dialog, DialogActions, Typography } from '@mui/material';
import React from 'react';

import CustomButton from '../../../../../../../lib/designSystem/Button';
import HeaderWithActions from '../../../../../../../lib/designSystem/HeaderWithActions';
import { LightTooltip } from '../../../../../../../lib/designSystem/WhiteTooltip';

const RegisterSelector = (props: any) => {
  const {
    open,
    setOpen,
    setOpenMultiPayment,
    setOpenMultiCreateResell,
    setOpenMultiBuyBack,
    setOpenMultiOwnCollection,
    resells,
    selectedResellIds,
    setPayments,
  } = props;

  const preparePayments = () => {
    const resellsSelected = resells.filter((resell: any) =>
      selectedResellIds.includes(resell.id),
    );
    const paymentsWithAmount = resellsSelected.map((resell: any) => ({
      ...resell,
      factoringResellId: resell.id,
      documentAmount: resell.amount,
      amount: resell.amount - resell.amountPaid,
      businessIdentifier: resell.document.businessIdentifier,
    }));
    return paymentsWithAmount;
  };

  const handleMultiPayment = () => {
    const paymentsWithAmount = preparePayments();
    setPayments(paymentsWithAmount);
    setOpenMultiPayment(true);
    setOpen(false);
  };

  const handleMultiBuyBack = () => {
    const paymentsWithAmount = preparePayments();
    setPayments(paymentsWithAmount);
    setOpenMultiBuyBack(true);
    setOpen(false);
  };

  const handleCreateResell = () => {
    setOpenMultiCreateResell(true);
    setOpen(false);
  };

  return (
    <Dialog maxWidth="xs" fullWidth open={open} onClose={() => setOpen(false)}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <div>
          <HeaderWithActions title="Qué necesitas registrar?" />
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                padding: '10px 0px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>
                <CustomButton
                  onClick={() => handleMultiPayment()}
                  color="primary"
                  disabled={selectedResellIds.length === 0}
                >
                  Registrar pagos
                </CustomButton>
              </div>
              <div>
                {selectedResellIds.length === 0 && (
                  <LightTooltip
                    title={
                      <Typography variant="body1" style={{ padding: 10 }}>
                        Selecciona al menos una venta
                      </Typography>
                    }
                  >
                    <Info sx={{ cursor: 'pointer' }} />
                  </LightTooltip>
                )}
              </div>
            </div>
            <div
              style={{
                padding: '10px 0px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>
                <CustomButton
                  onClick={() => handleMultiBuyBack()}
                  color="primary"
                  disabled={selectedResellIds.length === 0}
                >
                  Recomprar facturas
                </CustomButton>
              </div>
              <div>
                {selectedResellIds.length === 0 && (
                  <LightTooltip
                    title={
                      <Typography variant="body1" style={{ padding: 10 }}>
                        Selecciona al menos una venta
                      </Typography>
                    }
                  >
                    <Info sx={{ cursor: 'pointer' }} />
                  </LightTooltip>
                )}
              </div>
            </div>
            <div style={{ padding: '10px 0px' }}>
              <CustomButton
                onClick={() => handleCreateResell()}
                color="primary"
              >
                Registrar venta
              </CustomButton>
            </div>
          </div>
        </div>
        <DialogActions>
          <CustomButton onClick={() => setOpen(false)} color="secondary">
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default RegisterSelector;
